<template lang="pug">
    #modal-editar-protocolos-vinculados
        el-dialog(
            width='80%',
            title='Editar protocolos vinculados',
            :visible.sync='mostrar',
            :close-on-click-modal='false',
            :before-close='fechar'
        )
            main
                .modal-editar-protocolos-vinculados__desabilitados
                    h3.mb-3 Desabilitadas
                    el-card(shadow='never', :body-style='{ padding: "10px" }')
                        el-table.box-card(
                            ref='tabelaDesabilitadas',
                            :data='protocolosDesabilitadosFiltrados',
                            size='mini',
                            height='350px',
                            @selection-change='alterarProtocolosDesabilitadosSelecionados'
                        )
                            el-table-column(type='selection', width='50')
                            el-table-column(
                                label='Nome',
                                prop='descricao',
                                sortable,
                                :min-width='100'
                            )
                            el-table-column(align='right')
                                template(slot='header', slot-scope='scope')
                                    el-input(
                                        v-model='filtroProtocolosDesabilitados',
                                        size='mini',
                                        placeholder='Pesquisar'
                                    )

                        footer.mt-2
                            span {{ protocolosDesabilitadosSelecionados.length }} {{ protocolosDesabilitadosSelecionados.length === 1 ? 'protocolo selecionado' : 'protocolos selecionados' }}

                el-button-group
                    BaseButton(
                        type='primary',
                        icon='el-icon-arrow-left',
                        size='medium',
                        @click='desabilitarProtocolos'
                    )
                    BaseButton(
                        type='primary',
                        icon='el-icon-arrow-right',
                        size='medium',
                        @click='habilitarProtocolos'
                    )

                .modal-editar-protocolos-vinculados__habilitados
                    h3.mb-3
                        | Habilitadas

                    el-card(shadow='never', :body-style='{ padding: "10px" }')
                        el-table.box-card(
                            ref='tabelaHabilitadas',
                            :data='protocolosHabilitadosFiltrados',
                            size='mini',
                            height='350px',
                            @selection-change='alterarProtocolosHabilitadosSelecionados'
                        )
                            el-table-column(type='selection', width='50')
                            el-table-column(
                                label='Nome',
                                prop='descricao',
                                sortable,
                                :min-width='100'
                            )
                            el-table-column(align='right')
                                template(slot='header', slot-scope='scope')
                                    el-input(
                                        v-model='filtroProtocolosHabilitados',
                                        size='mini',
                                        placeholder='Pesquisar'
                                    )

                        footer.mt-2
                            span {{ protocolosHabilitadosSelecionados.length }} {{ protocolosHabilitadosSelecionados.length === 1 ? 'protocolo selecionado' : 'protocolos selecionados' }}

            footer(slot='footer')
                BaseButton(size='mini', @click='fechar') Cancelar
                BaseButton(size='mini', type='primary' :disabled="this.protocolosHabilitados.length === 0", @click='confirmar') Confirmar
    </template>

    <script>
    import { ProtocolosService } from '@/services/ProtocolosService';
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';

    export default {
        name: 'ModalEditarProtocolosVinculados',

        components: {
            BaseButton
        },

        props: {
            mostrar: {
                type: Boolean,
                required: true
            },
            empresa: {
                type: Object,
                required: true
            },
            protocolos: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                filtroProtocolosDesabilitados: '',
                filtroProtocolosHabilitados: '',
                protocolosDesabilitados: [],
                protocolosHabilitados: [],
                protocolosDesabilitadosSelecionados: [],
                protocolosHabilitadosSelecionados: []
            };
        },

        computed: {
            protocolosDesabilitadosFiltrados() {
                return this.protocolosDesabilitados.filter(protocolo =>
                    protocolo.descricao
                        .toLowerCase()
                        .includes(this.filtroProtocolosDesabilitados.toLowerCase())
                );
            },

            protocolosHabilitadosFiltrados() {
                return this.protocolosHabilitados.filter(protocolo =>
                    protocolo.descricao
                        .toLowerCase()
                        .includes(this.filtroProtocolosHabilitados.toLowerCase())
                );
            }
        },

        watch: {
            mostrar() {
                if (this.mostrar) {
                    this.buscarProtocolosHabilitados();
                }
            }
        },

        methods: {
            async buscarProtocolosHabilitados() {
                const protocolos = await ProtocolosService.buscarProtocolosPorEmpresa(
                    this.empresa.idEmpresa
                );
                this.protocolosHabilitados = protocolos.data;

                const codigosProtocolosHabilitados = this.protocolosHabilitados.map(
                    ({ codigo }) => codigo
                );

                this.protocolosDesabilitados = this.protocolos.filter(
                    ({ codigo }) => !codigosProtocolosHabilitados.includes(codigo)
                );
            },

            fechar() {
                this.filtroProtocolosDesabilitados = '';
                this.filtroProtocolosHabilitados = '';
                this.protocolosDesabilitadosSelecionados = [];
                this.protocolosHabilitadosSelecionados = [];

                this.limparSelecoes();

                this.$emit('fechar');
            },

            alterarProtocolosDesabilitadosSelecionados(linhas) {
                this.protocolosDesabilitadosSelecionados = linhas;
            },

            alterarProtocolosHabilitadosSelecionados(linhas) {
                this.protocolosHabilitadosSelecionados = linhas;
            },

            limparSelecoes() {
                this.$refs.tabelaDesabilitadas.clearSelection();
                this.$refs.tabelaHabilitadas.clearSelection();
            },

            habilitarProtocolos() {
                this.protocolosHabilitados = [
                    ...this.protocolosHabilitados,
                    ...this.protocolosDesabilitadosSelecionados
                ];

                const codigosProtocolosHabilitados = this.protocolosHabilitados.map(
                    ({ codigo }) => codigo
                );

                this.protocolosDesabilitados = this.protocolos.filter(
                    ({ codigo }) => !codigosProtocolosHabilitados.includes(codigo)
                );

                this.limparSelecoes();
            },

            desabilitarProtocolos() {
                this.protocolosDesabilitados = [
                    ...this.protocolosDesabilitados,
                    ...this.protocolosHabilitadosSelecionados
                ];

                const codigosProtocolosDesabilitados = this.protocolosDesabilitados.map(
                    ({ codigo }) => codigo
                );

                this.protocolosHabilitados = this.protocolos.filter(
                    ({ codigo }) => !codigosProtocolosDesabilitados.includes(codigo)
                );

                this.limparSelecoes();
            },

            confirmar() {
                this.$emit('setProtocolosHabilitados', this.protocolosHabilitados);
                this.fechar();
            }
        }
    };
    </script>
    <style lang="scss">
    #modal-editar-protocolos-vinculados {
        main {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;

            footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }

        footer {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
        }

        .modal-editar-protocolos-vinculados__desabilitados,
        .modal-editar-protocolos-vinculados__habilitados {
            width: 40%;

            h3 {
                display: flex;
                font-size: 16px;
                justify-content: space-between;
                align-items: center;
                height: 28px;
            }
        }
    }
    </style>
